import {
  FAQS,
  FooterLinks,
  NavSubmenuLinks,
  TERMS_AND_CONDITION,
  CheckoutTermsCheckbox,
  PASS_PURCHASE_SUCCESS_MESSAGE,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const losangelesangels_pass: TTeamConfig = {
  TEAM_SCHEMA: "losangelesangels_pass",
  TEAM_FULL_NAME: "Los Angeles Angels",
  BROWSER_TITLE: "Los Angeles Angels Pass",
  CLIENT_ID: "RiOllv9Wd5OzMJk7GyrrhOUllSYOkTIF1gd7nrH9Zm7F9auv",
  VENDOR: constants.vendorUUIDs.ticketsdotcom,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#BA0021",
    COLORS_SECONDARY: "#000000",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    IS_INTERCOM_ENABLED: true,

    NAV_MENU: {
      HIDE_AUTH_BUTTONS: false,
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: false,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
      LOGIN_LABEL: "Manage Pass",
      HIDE_SIGN_OUT_BUTTON: true,
    },

    ACCOUNT_MANAGER_URL:
      "https://mlb.tickets.com/?orgid=52470&agency=ANGM_MYTIXX&tfl=Los_Angeles_Angels-Tickets-Manage_Your_Tickets-button-x0-Desktop-Landscape&adobe_mc=MCMID=14093986887918835934395933928119221636|MCORGID=A65F776A5245B01B0A490D44%40AdobeOrg|TS=1770660404&_gl=1*3kyb14*_ga*NDg0NDg5NTAwLjE3NzA2NTg3OTk.*_ga_N8YFCZLYSZ*czE3NzA2NTg3OTgkbzEkZzEkdDE3NzA2NjA0MDUkajYwJGwwJGg4ODkzNDcwODM.*_fplc*ZlBhakJ0RDREdUVBMm92bDMzWklOZEtHNFhvekZLJTJCbjR3JTJGUiUyQm5NdjJ3ZkF2aVFmOVZsWFZocXNsTlRoVWg3N2VuSTFMTTlEUlAweG85QkJHTjdNbGNpbXNPcWJmQTBDZFJxaFhpU290TlVOJTJGOUYlMkJEVTdaYlhZZHQxT01MUSUzRCUzRA..*_gcl_au*MTQxMjc5MzYwMi4xNzcwNjU4Nzk5",

    FOOTER: {
      LINKS: FooterLinks,
      COPYRIGHT_TEXT: `© ${new Date().getFullYear()} MLB Advanced Media, L.P. All rights reserved`,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      HIDE_PASS_DETAILS: true,
    },

    PASS: {
      ADD_SERVICE_FEE_TO_PRICE: true,
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Subscribe Now",
      SHOW_FAQ_BUTTON: true,
    },

    SHOW_ALL_PASSES_UNDER_BANNER: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_COLOR: "#BA0021",
    },

    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
      CHECKOUT_TERMS_CHECKBOX: <CheckoutTermsCheckbox />,
    },

    ADD_ONS_LABEL: "Tickets",
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
      NO_UPCOMING_RENEWAL_PERIOD_MESSAGE:
        "You will be able to view and manage your subscriptions after April 15, 2026.",
    },
  },

  AUTH_PAGE_SETTINGS: {
    HIDE_ACCOUNT_DETAILS: true,
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <TERMS_AND_CONDITION />,
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/los-angeles-angels-of-anaheim.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/Los%20Angeles%20Angels/Pass%20Assets/Background_Image_1920x1080_A.png",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
    PRE_PURCHASE_FAQS: FAQS,
  },
};
